<template>
    <div>
        <div class="row" v-if="hideData">
            <div class="col-sm-9">
                <p>
                    {{ $t('RISK_FACTORS_INFO') }}
                </p>
            </div>
            <div class="col-sm-3">
                <button class="app-btn app-btn-primary pull-right" @click="hideData = !hideData">
                    {{ $t('CHECK_DATA') }}
                </button>
            </div>
        </div>

        <div class="data-details" v-else>
            <div class="row row-flex-align-bottom">
                <div class="col-xs-12 col-sm-8" v-if="step3q1 === false">
                    <div class="row custom-span">
                        <div class="icon-group col-xs-12 col-sm-4">
                            <img class="icon-img" src="../../../assets/images/icons/ico-growth.png" />
                            <label>{{ $t('HEIGHT') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{ userHeightString }}</span>
                        </div>
                        <div class="icon-group col-xs-12 col-sm-4">
                            <img class="icon-img icon-img--big" src="../../../assets/images/icons/ico-weight.png" />
                            <label>{{ $t('WEIGHT') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{ userWeightString }}</span>
                        </div>
                        <div class="icon-group col-xs-12 col-sm-4">
                            <img class="icon-img icon-img--big" src="../../../assets/images/icons/ico-bmi.png" />
                            <label>BMI:</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{ userBMIString }}</span>
                        </div>
                    </div>
                </div>

                <div class="col-xs-12" v-else>
                    <div class="row">
                        <div class="col-xs-12">
                            <!--1/7 | wzrost, waga, BMI-->
                            <survey-step3-q1
                                :single="true"
                                @cancel="hideEditingMode(false)"
                                @save="hideEditingMode(true)"
                            ></survey-step3-q1>
                        </div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4 text-right">
                    <a @click="step3q1 = true" v-if="step3q1 === false"
                        >{{ $t('CHANGE') }} <img src="../../../assets/images/arrow-red.png" class="arrow-img"
                    /></a>
                </div>
            </div>
            <hr />

            <div class="row row-flex-align-bottom">
                <div class="col-xs-12 col-sm-8" v-if="step3q2 === false">
                    <div class="row">
                        <div class="col-xs-12">
                            <label>{{ $t('ZGRUBIENIE_GUZEK') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{
                                survey.section3.q2_1 == 'YES' || survey.section3.q2_2 == 'YES' ? $t('YES') : $t('NO')
                            }}</span>
                        </div>
                    </div>
                </div>

                <div class="col-xs-12" v-else>
                    <div class="row">
                        <div class="col-xs-12">
                            <!--2/7 | Czy wyczuwasz w piersiach nie pokojące zmiany -->
                            <survey-step3-q2
                                :single="true"
                                @cancel="hideEditingMode(false)"
                                @save="hideEditingMode(true)"
                            ></survey-step3-q2>
                        </div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4 text-right">
                    <a @click="step3q2 = true" v-if="step3q2 === false"
                        >{{ $t('CHANGE') }} <img src="../../../assets/images/arrow-red.png" class="arrow-img"
                    /></a>
                </div>
            </div>
            <hr />

            <div class="row row-flex-align-bottom">
                <div class="col-xs-12 col-sm-8" v-if="step3q2_observe === false">
                    <div class="row">
                        <div class="col-xs-12">
                            <label>{{ $t('DO_YOU_SEE_CHANGES_IN_BREAST') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{
                                survey.section3.q2_1_observe == 'YES' || survey.section3.q2_2_observe == 'YES'
                                    ? $t('YES')
                                    : $t('NO')
                            }}</span>
                        </div>
                    </div>
                </div>

                <div class="col-xs-12" v-else>
                    <div class="row">
                        <div class="col-xs-12">
                            <!--2/7 | Czy wyczuwasz w piersiach nie pokojące zmiany -->
                            <survey-step3-q2-observe
                                :single="true"
                                @cancel="hideEditingMode(false)"
                                @save="hideEditingMode(true)"
                            ></survey-step3-q2-observe>
                        </div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4 text-right">
                    <a @click="step3q2_observe = true" v-if="step3q2_observe === false"
                        >{{ $t('CHANGE') }} <img src="../../../assets/images/arrow-red.png" class="arrow-img"
                    /></a>
                </div>
            </div>
            <hr />

            <div class="row row-flex-align-bottom">
                <div class="col-xs-12 col-sm-8" v-if="step3q3 === false">
                    <div class="row">
                        <div class="col-xs-12">
                            <label>{{ $t('DID_YOU_USE_OESTROGENS') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{ $t(survey.section3.q3) }}</span>
                        </div>
                    </div>
                </div>

                <div class="col-xs-12" v-else>
                    <div class="row">
                        <div class="col-xs-12">
                            <!--3/7 | Czy stosujesz lub kiedykolwiek stosowałaś leki antykoncepcyjne -->
                            <survey-step3-q3
                                :single="true"
                                @cancel="hideEditingMode(false)"
                                @save="hideEditingMode(true)"
                            ></survey-step3-q3>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4 text-right">
                    <a @click="step3q3 = true" v-if="step3q3 === false"
                        >{{ $t('CHANGE') }} <img src="../../../assets/images/arrow-red.png" class="arrow-img"
                    /></a>
                </div>
            </div>
            <hr />

            <div class="row row-flex-align-bottom">
                <div class="col-xs-12 col-sm-8" v-if="step3q4 === false">
                    <div class="row">
                        <div class="col-xs-12">
                            <label>{{ $t('DO_YOU_USE_HTZ') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{ $t(survey.section3.q4) }}</span>
                        </div>
                    </div>
                </div>

                <div class="col-xs-12" v-else>
                    <div class="row">
                        <div class="col-xs-12">
                            <!--4/7 | Czy stosujesz hormonoterapię zastępczą (HTZ) -->
                            <survey-step3-q4
                                :single="true"
                                @cancel="hideEditingMode(false)"
                                @save="hideEditingMode(true)"
                            ></survey-step3-q4>
                        </div>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4 text-right">
                    <a @click="step3q4 = true" v-if="step3q4 === false"
                        >{{ $t('CHANGE') }} <img src="../../../assets/images/arrow-red.png" class="arrow-img"
                    /></a>
                </div>
            </div>
            <hr />

            <div class="row row-flex-align-bottom">
                <div class="col-xs-12 col-sm-8" v-if="step3q5_before === false">
                    <div class="row">
                        <div class="col-xs-12">
                            <label>{{ $t('CANCER_AMONG_FAMILY_BEFORE') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{
                                $t(survey.section3.q5_before)
                            }}</span>
                        </div>
                    </div>
                </div>

                <div class="col-xs-12" v-else>
                    <div class="row">
                        <div class="col-xs-12">
                            <!--5/7 | Czy wśród spokrewnionych z Tobą kobiet stwierdzano zachorowania na raka piersi lub jajnika -->
                            <survey-step3-q5
                                :single="true"
                                @cancel="hideEditingMode(false)"
                                @save="hideEditingMode(true)"
                            ></survey-step3-q5>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4 text-right">
                    <a @click="step3q5_before = true" v-if="step3q5_before === false"
                        >{{ $t('CHANGE') }} <img src="../../../assets/images/arrow-red.png" class="arrow-img"
                    /></a>
                </div>
            </div>
            <hr />

            <div class="row row-flex-align-bottom">
                <div class="col-xs-12 col-sm-8" v-if="step3q5_after === false">
                    <div class="row">
                        <div class="col-xs-12">
                            <label>{{ $t('CANCER_AMONG_FAMILY_AFTER') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{
                                $t(survey.section3.q5_after)
                            }}</span>
                        </div>
                    </div>
                </div>

                <div class="col-xs-12" v-else>
                    <div class="row">
                        <div class="col-xs-12">
                            <!--5/7 | Czy wśród spokrewnionych z Tobą kobiet stwierdzano zachorowania na raka piersi lub jajnika -->
                            <survey-step3-q5-after
                                :single="true"
                                @cancel="hideEditingMode(false)"
                                @save="hideEditingMode(true)"
                            ></survey-step3-q5-after>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4 text-right">
                    <a @click="step3q5_after = true" v-if="step3q5_after === false"
                        >{{ $t('CHANGE') }} <img src="../../../assets/images/arrow-red.png" class="arrow-img"
                    /></a>
                </div>
            </div>
            <hr />

            <div class="row row-flex-align-bottom">
                <div class="col-xs-12 col-sm-8" v-if="step3q6 === false">
                    <div class="row">
                        <div class="col-xs-12">
                            <label>{{ $t('BRCA_AMONG_FAMILY') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{ $t(survey.section3.q6) }}</span>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12" v-else>
                    <div class="row">
                        <div class="col-xs-12">
                            <!--6/7 | Czy Ty lub ktoś z Twoich bliskich ma stwierdzoną mutację w genie BRCA1/BRCA2 -->
                            <survey-step3-q6
                                :single="true"
                                @cancel="hideEditingMode(false)"
                                @save="hideEditingMode(true)"
                            ></survey-step3-q6>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4 text-right">
                    <a @click="step3q6 = true" v-if="step3q6 === false"
                        >{{ $t('CHANGE') }} <img src="../../../assets/images/arrow-red.png" class="arrow-img"
                    /></a>
                </div>
            </div>
            <hr />

            <div class="row row-flex-align-bottom">
                <div class="col-xs-12 col-sm-8" v-if="step3q7 === false">
                    <div class="row">
                        <div class="col-xs-12">
                            <label>{{ $t('DO_YOU_HAVE_SCARS') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{ $t(survey.section3.q7) }}</span>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12" v-else>
                    <div class="row">
                        <div class="col-xs-12">
                            <!--7/7 | Czy masz blizny na piersiach-->
                            <survey-step3-q7
                                :single="true"
                                @cancel="hideEditingMode(false)"
                                @save="hideEditingMode(true)"
                            ></survey-step3-q7>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4 text-right">
                    <a @click="step3q7 = true" v-if="step3q7 === false"
                        >{{ $t('CHANGE') }} <img src="../../../assets/images/arrow-red.png" class="arrow-img"
                    /></a>
                </div>
            </div>
            <hr />
            <div class="row row-flex-align-bottom">
                <div class="col-xs-12 col-sm-8" v-if="step3q8 === false">
                    <div class="row">
                        <div class="col-xs-12">
                            <label>{{ $t('DO_YOU_HAVE_CONFIRMED_BREAST_CHANGES') }}</label>
                            <br />
                            <span class="text-input white-input-border disabled">{{
                                survey.section3.q8_1 == 'YES' || survey.section3.q8_2 == 'YES' ? $t('YES') : $t('NO')
                            }}</span>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12" v-else>
                    <div class="row">
                        <div class="col-xs-12">
                            <!--7/7 | Czy masz blizny na piersiach-->
                            <survey-step3-q8
                                :single="true"
                                @cancel="hideEditingMode(false)"
                                @save="hideEditingMode(true)"
                            ></survey-step3-q8>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-4 text-right">
                    <a @click="step3q8 = true" v-if="step3q8 === false"
                        >{{ $t('CHANGE') }} <img src="../../../assets/images/arrow-red.png" class="arrow-img"
                    /></a>
                </div>
            </div>
            <button class="app-btn app-btn-primary pull-right mt-5" @click.prevent="collapse">
                {{ $t('COLLAPSE') }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import surveyStep3Q1 from '../../modals/main-survey/survey-step3-q1.vue';
import surveyStep3Q2 from '../../modals/main-survey/survey-step3-q2.vue';
import surveyStep3Q2Observe from '../../modals/main-survey/survey-step3-q2-observe.vue';
import surveyStep3Q3 from '../../modals/main-survey/survey-step3-q3.vue';
import surveyStep3Q4 from '../../modals/main-survey/survey-step3-q4.vue';
import surveyStep3Q5 from '../../modals/main-survey/survey-step3-q5.vue';
import surveyStep3Q5After from '../../modals/main-survey/survey-step3-q5-after.vue';
import surveyStep3Q6 from '../../modals/main-survey/survey-step3-q6.vue';
import surveyStep3Q7 from '../../modals/main-survey/survey-step3-q7.vue';
import surveyStep3Q8 from '../../modals/main-survey/survey-step3-q8.vue';
import { mapFromMedicalData, mapMedicalData } from './../../../main';
import Vue from 'vue';
import { calculateBMI } from '../../../plugins/customSettings';

export default {
    data() {
        return {
            hideData: true,
            step3q1: false,
            step3q2: false,
            step3q2_observe: false,
            step3q3: false,
            step3q4: false,
            step3q5_before: false,
            step3q5_after: false,
            step3q6: false,
            step3q7: false,
            step3q8: false,
        };
    },
    computed: {
        ...mapGetters({
            survey: 'survey',
        }),
        userWeightKilos() {
            return this.$store.getters.survey.section3.user_weight;
        },
        userWeightString() {
            return this.decimalSeparator(this.weightFormat(this.userWeightKilos));
        },
        userHeightCentimeters() {
            return this.$store.getters.survey.section3.user_height;
        },
        userHeightString() {
            return this.decimalSeparator(this.heightFormat(this.userHeightCentimeters));
        },
        userBMI() {
            return calculateBMI(this.userWeightKilos, this.userHeightCentimeters);
        },
        userBMIString() {
            return this.decimalSeparator(this.userBMI);
        },
    },
    components: {
        surveyStep3Q1,
        surveyStep3Q2,
        surveyStep3Q2Observe,
        surveyStep3Q3,
        surveyStep3Q4,
        surveyStep3Q5,
        surveyStep3Q5After,
        surveyStep3Q6,
        surveyStep3Q7,
        surveyStep3Q8,
    },
    methods: {
        hideEditingMode(sendData) {
            this.step3q1 = false;
            this.step3q2 = false;
            this.step3q2_observe = false;
            this.step3q3 = false;
            this.step3q4 = false;
            this.step3q5_before = false;
            this.step3q5_after = false;
            this.step3q6 = false;
            this.step3q7 = false;
            this.step3q8 = false;

            if (sendData) {
                mapMedicalData();

                Vue.http.post('/openehr/api/composition/', this.$store.state.medicalData);
                console.log('/composition');
                //send BMI to
                let dataBMI = {
                    heightM: this.userHeightCentimeters / 100,
                    weightKg: this.userWeightKilos,
                    bmi: this.userBMI,
                };

                Vue.http.post('/examination/api/other/survey/updateBMI', dataBMI);
            } else {
                mapFromMedicalData();
            }
        },
        collapse() {
            this.hideData = true;
            this.$scrollTo('#CzynnikiRyzyka', 500, { offset: -30 });
        },
    },
};
</script>

<style scoped>
label {
    font-size: 16px;
    font-weight: 400;
}

.data-details {
    margin-bottom: 100px;
}

.icon-group {
    position: relative;
    padding-left: 40px;
}

.icon-group label {
    font-size: 14px;
    color: #67635f;
    margin: 0;
}

.icon-group input[disabled] {
    height: 18px;
    padding: 0;
    line-height: 1;
    border-radius: 0;
}

.icon-img {
    width: 15px;
    height: auto;
    position: absolute;
    top: 5px;
    left: 15px;
}

.icon-img--big {
    width: 18px;
    top: 10px;
}

.arrow-img {
    height: 7px;
    margin-bottom: 4px;
}

.custom-span span {
    height: 30px;
}
</style>



// WEBPACK FOOTER //
// risk-factors.vue?2bbbe7fe